<script setup>
const props = defineProps({
  tags: {
    type: Array,
    required: true,
  },
})
const { sortChildren } = useTagSort()

const interests = computed(() => {
  return props?.tags?.reduce((acc, tag) => {
    if ((tag?.parent?.parent?.slug || tag?.parent?.slug) === 'functies') {
      const parentFromAcc = acc.find(
        (parent) => parent.slug === 'gezochte-functies',
      )
      if (parentFromAcc) {
        parentFromAcc.children.push(tag)
      } else {
        acc.push({
          name: 'Gezochte functies',
          slug: 'gezochte-functies',
          children: [tag],
        })
      }
    } else {
      const parentFromAcc = acc.find(
        (parent) => parent.slug === tag?.parent?.slug,
      )
      if (parentFromAcc) {
        parentFromAcc.children.push(tag)
      } else {
        acc.push({
          ...tag.parent,
          children: [tag],
        })
      }
    }
    return acc
  }, [])
})
</script>

<template>
  <div class="max-w-[700px]">
    <div class="flex flex-col flex-wrap items-start">
      <div
        v-for="parent in interests"
        :key="parent.id"
        class="my-1 flex w-full flex-col gap-2 lg:flex-row lg:gap-6"
      >
        <h3 class="basis-1/3 font-sans text-lg text-secondary">
          {{ parent.name }}
        </h3>
        <div
          class="flex max-w-sm grow basis-2/3 flex-row flex-wrap items-start"
        >
          <Tag
            v-for="tag in sortChildren(parent.children)"
            :key="tag.id"
            :text="tag.name"
            :margin-bottom="true"
            theme="outlined"
          />
        </div>
      </div>
    </div>
  </div>
</template>
